<template>
    <div>
        <Navbar class="bg-white" />
        <PageTitle pageTitle="Smart Glass" />
        <SmartGlassDetails />
        <Newsletter />
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import PageTitle from '../Common/PageTitle'
import SmartGlassDetails from '../SingleProjects/SmartGlassDetails'
import Newsletter from '../Common/Newsletter'
import Footer from '../Layout/Footer'

export default {
    name: 'SmartGlass',
    components: {
        Navbar,
        PageTitle,
        SmartGlassDetails,
        Newsletter,
        Footer,
    }
}
</script>